import Link from 'next/link';
import styled from 'styled-components';
import { parseISO, format } from 'date-fns';
import es from 'date-fns/locale/es';
// import en from 'date-fns/locale/en';
const dateLocales = {
  es
};
// import useSWR from 'swr';
// import format from 'comma-number';

// import fetcher from '@/lib/fetcher';

const GuidePostItem = styled.div`
  border-bottom: ${({ isLast }) => (isLast ? '0' : 'var(--border)')};
  padding: 2rem 0;
  a {
    font-weight: 400;
    color: var(--text-color);
    font-family: var(--font-base);
    .title {
      display: grid;
      grid-template-columns: 70% auto;
      grid-gap: 0.5rem;
      align-items: center;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
        align-items: inherit;
      }
      h4 {
        margin: 0;
        font-weight: 500;
        font-size: 1.875rem;
        padding-bottom: 0.5rem;
      }
      .post-dates {
        font-size: 1rem;
        color: var(--muted-strong);
        text-align: right;
      }
    }
    p {
      margin: 0;
      padding-bottom: 0.5rem;
    }
    &:hover {
      h4 {
        text-decoration: underline;
      }
    }
  }
`;

const GuidePost = ({ title, summary, slug, isLast, publishedAt, locale, ...rest }) => {
  const isENLocale = locale === 'en';
  const localeOptions = isENLocale ? {} : { locale: dateLocales[`${locale}`] };
  // const { data } = useSWR(`/api/views/${slug}`, fetcher);
  // const views = data?.total;
  return (
    <GuidePostItem isLast={isLast}>
      <Link href={`/guides/${slug}`}>
        <a>
          <div>
            <div>
              <div className="title">
                <h4>{title}</h4>
                <div className="post-dates">
                  {publishedAt &&
                    format(parseISO(publishedAt), 'MMMM dd, yyyy', {
                      ...localeOptions
                    })}
                </div>
              </div>
              <p>{/* {`${views ? format(views) : '–––'} views`} */}</p>
            </div>
            <p>{summary}</p>
          </div>
        </a>
      </Link>
    </GuidePostItem>
  );
};

export default GuidePost;
